import { render, staticRenderFns } from "./message-type.vue?vue&type=template&id=08a353c6&scoped=true"
import script from "./message-type.vue?vue&type=script&lang=js"
export * from "./message-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a353c6",
  null
  
)

export default component.exports